import { Repository } from "../../adapters/repository";
import { IconExtractor } from "../../adapters/iconExtractor";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(
  repository: Repository,
  extractor: IconExtractor,
): Interactor {
  return ({ project, link, nextLink }) =>
    present(
      repository
        .editProjectExternalLink(project, link, nextLink)
        .then(() =>
          extractor.extractIcon(nextLink).then((icon) => ({
            project,
            link,
            nextLink: { ...nextLink, icon },
          })),
        )
        .catch(() =>
          Promise.reject({
            project,
            link,
            nextLink,
          }),
        ),
    );
}

export type { Interactor };

export { createInteractor };
